import request from '@/utils/request'

const urlPrefix = '/documents'

export function getDocument (id) {
  return request.get(`${urlPrefix}/${id}`)
}

export function updateDocument (id, data) {
  return request.put(`${urlPrefix}/${id}`, data)
}

export function deleteDocument (id) {
  return request.delete(`${urlPrefix}/${id}`)
}

export function getDocumentList (params) {
  return request.get(urlPrefix, { params })
}

export function createDocument (data) {
  return request.post(urlPrefix, data)
}
